import React, { useEffect, useState } from 'react';
import { Clock, Loader2 } from 'lucide-react';
import { api, API_BASE } from '../services/api';
import { ROOM_LABELS } from '../types';

interface Render {
  id: number;
  staged_filename: string;
  original_filename?: string | null;
  room_type: string;
  mode: string;
  generation_type: string;
  created_at: string;
}

interface Props {
  propertyId: number | null;
  version: number; // increment om te refreshen na nieuwe render
  onRestore: (stagedUrl: string) => void;
}


export const HistoryPanel: React.FC<Props> = ({ propertyId, version, onRestore }) => {
  const [renders, setRenders] = useState<Render[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!propertyId) { setRenders([]); return; }
    setLoading(true);
    api.get<Render[]>(`/api/properties/${propertyId}/renders`)
      .then(data => setRenders(Array.isArray(data) ? data : []))
      .catch(() => setRenders([]))
      .finally(() => setLoading(false));
  }, [propertyId, version]);

  if (!propertyId || (!loading && renders.length === 0)) return null;

  return (
    <div className="space-y-3">
      <label className="text-[11px] font-bold text-ink/55 uppercase tracking-[0.08em] flex items-center gap-2">
        <Clock size={13} />
        Renders van deze woning
      </label>
      {loading ? (
        <div className="flex items-center gap-2 text-ink/40 text-xs">
          <Loader2 size={13} className="animate-spin" /> Laden…
        </div>
      ) : (
        <div className="flex gap-2.5 overflow-x-auto pb-1 -mx-1 px-1">
          {renders.map(r => (
            <button
              key={r.id}
              onClick={() => onRestore(`${API_BASE}/api/renders/${r.staged_filename}`)}
              className="shrink-0 w-20 h-20 rounded-xl border border-black/10 hover:border-accent/40 overflow-hidden relative group transition-all shadow-[0_1px_2px_rgba(0,0,0,0.04)] hover:shadow-[0_4px_12px_-4px_rgba(0,0,0,0.15)]"
              title={`${ROOM_LABELS[r.room_type] || r.room_type} • ${new Date(r.created_at).toLocaleString('nl-NL', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}`}
            >
              <img
                src={`${API_BASE}/api/renders/${r.staged_filename}`}
                alt="render"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                <span className="text-white text-[10px] font-bold uppercase tracking-wide">Laden</span>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
